import * as localStorage from '@/utils/localStorage'
import KPaymentUtils from '@/utils/KPaymentGateway.util'
import dayjs, { createDayjsDate } from '@/utils/dayjs'
import * as defaultValue from '../utils/defaultValue'
import { isBkkZipCode } from '../utils/zipCode'

export default {
  install (Vue) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$utils = {
      ...localStorage,
      ...KPaymentUtils,
      isBkkZipCode,
      dayjs,
      createDayjsDate,
      customerTypeText: (customerTypes, customerTypeId) => {
        const findCustomerType = customerTypes.find(
          (customerType) => customerTypeId === customerType.value
        )

        return findCustomerType ? findCustomerType.text : '-'
      },
      isJuristicCustomer (customerTypeId) {
        if (!customerTypeId) {
          return false
        }
        return customerTypeId !== defaultValue.NORMAL_CUSTOMER_TYPE_VALUE
      },
      isHeadquarter (branchNumber) {
        return branchNumber === defaultValue.HEADQUARTER_BRANCH_NUMBER
      },
      citizenIdText (isJuristicCustomer) {
        return isJuristicCustomer
          ? 'เลขประจำตัวผู้เสียภาษี'
          : 'เลขประจำตัวประชาชน'
      },
      scrollToErrorField (formRef, vm) {
        setTimeout(() => {
          const errors = Object.entries(vm.$refs[formRef].errors)
            .map(([key, value]) => ({ key, value }))
            .filter((error) => error.value.length)
          vm.$refs[formRef].refs[errors[0].key].$el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
        }, 100)
      }
    }

    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$default = {
      ...defaultValue
    }
  }
}
